import React, { Fragment } from 'react';
import styled from "styled-components";
import quote from '../images/icons/quote.svg'

const Wrapper = styled.div`
    margin-left: ${props => props.marginLeft || 'auto'};
    margin-right: ${props => props.marginRight || 'auto'};
    margin-top: ${props => props.marginTop || 0};
    margin-bottom: ${props => props.marginBottomWrapper || '40px'};
    max-width: ${props => props.maxWidthWrapper || "100%"};
    color: ${props => props.color};

    ${props => props.theme.mediaQueries.medium}{
        max-width: ${props => props.maxWidthWrapperMediaQueriesMedium};
        margin-bottom: ${props => props.marginBottomWrapperMediaQueriesMedium};
    }
`;

const QuoteIcon = styled.svg`
    background-image: url(${quote});
    background-repeat: no-repeat;
    display: inline-block;
    height: 25px;
    width: 45px;
`

const P = styled.p`
    font-size: ${props => props.fontSizeP || '1.33rem'};
    line-height: ${props => props.lineHeightP || '24px'};
    margin-bottom: ${props => props.marinBottomP};

    ${props => props.theme.mediaQueries.medium}{
        font-size: 0.8rem;
    }
`

const Author = styled.p`
    margin-top: 24px;
    font-size: 1rem;
    line-height: 16px;
    color: #2A2A2A;
    opacity: 0.5;

    ${props => props.theme.mediaQueries.medium}{
        margin-top: 16px;
        font-size: 0.6rem;
    }
`

const From = styled.p`
    font-size: 1rem;
    line-height: 16px;
    color: #2A2A2A;
    opacity: 0.5;

    ${props => props.theme.mediaQueries.medium}{
        font-size: 0.6rem;
    }
`

const Quotes = ({
    headerText, 
    paragraphText,
    content,
    ...props
}) => {
    const renderContent = (content) => {
        return content.map((item, index) => {
            return(
                <Fragment key={index}>
                    <QuoteIcon />
                    <P
                       fontSizeP={item.fontSizeP}
                       lineHeightP={item.lineHeightP}
                       marinBottomP={item.marinBottomP}
                    >
                        {item.paragraphText}
                    </P>
                    <Author>{item.author}</Author>
                    <From>{item.from}</From>
                </Fragment>
            )
        })
    }

    return (
        <Wrapper {...props}>
            {renderContent(content)}
        </Wrapper>
    )
}

export default Quotes;